import { get } from "../helpers/config";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";

export const useGetDashboardStats = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async () => {
        return await get("dashboard/stats");
    }, options);
};
